import { postRequest } from 'utils/httpServices';
import axiosIns from 'utils/axios';

class leadsAPI {
  static list = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-lead-data`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static summary = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-lead-summary`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static create = (queryData = {}, config = {}) => {
    return postRequest(`v1/create-lead`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static details = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-lead-detail-data`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static update = (queryData = {}, config = {}) => {
    return postRequest(`v1/update-lead`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static downloadableReport = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: 'v1/download-partner-lead-data',
        method: 'POST',
        responseType: 'blob',
        data: queryData,
        headers: config.headers
      })
      .catch(() => ({ success: false, data: 'Something went wrong', status: 500 }));
  };
}

export default leadsAPI;
